export const BaseAuth = () => import.meta.env.VITE_APP_API_SERVICE_AUTH
export const BaseFile = () => import.meta.env.VITE_APP_API_SERVICE_FILE
export const BaseProvider = () => import.meta.env.VITE_APP_API_SERVICE_PROVIDER
export const BaseManagement = () => import.meta.env.VITE_APP_API_SERVICE_MANAGEMENT
export const BaseMaster = () => import.meta.env.VITE_APP_API_SERVICE_MASTER
export const BaseClinic = () => import.meta.env.VITE_APP_API_SERVICE_CLINIC
export const BasePurchase = () => import.meta.env.VITE_APP_API_SERVICE_PURCHASE
export const BaseSales = () => import.meta.env.VITE_APP_API_SERVICE_SALES
export const BaseWarehouse = () => import.meta.env.VITE_APP_API_SERVICE_WAREHOUSE
export const BaseFinance = () => import.meta.env.VITE_APP_API_SERVICE_FINANCE
export const BaseNewsletter = () => import.meta.env.VITE_APP_API_SERVICE_NEWSLETTER

export let token = () => localStorage.getItem("token") || ""

export const getDefault = (data: Record<string, any>): string => {
  return '?' + Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');
  // return `/${module}/search?qry=`+JSON.stringify(data).replaceAll("{","%7B").replaceAll("}","%7D").replaceAll("[","%5B").replaceAll("]","%5D")
}